import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";

export const ResetPasswordMessage: React.FC = () => {
  return (
    <Container>
      <TitleWrapper>送信完了</TitleWrapper>

      <Message>送信完了しました。</Message>
      <Message2>
        登録メールアドレスにパスワード再設定用URLを送信いたします。メールに記載されたURLから、新しいパスワードを設定してください。
      </Message2>

      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 60px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  padding: 43px 0 38px 0;
  display: flex;
  justify-content: center;
  font-family: "Hiragino Sans";
`;

const Message = styled.div`
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  font-family: "Hiragino Sans";
`;

const Message2 = styled.div`
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  line-height: 21px;
  margin-bottom: 320px;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    height: auto;
    line-height: 1;
    font-weight: 500;
    font-family: "Hiragino Sans";
  }
`;
